var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"minigame-label"},[_c('span',{staticClass:"minigame-label__icon"},[_c('Icon',{attrs:{"name":_vm.icon,"group":"minigames","size":18}})],1),_c('span',{staticClass:"minigame-label__title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }